import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SharedServices } from "./shared.service";
import { domain } from "../variables/domain";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AgentCallingService {
  constructor(
    private http: HttpClient,
    private sharedServices: SharedServices
  ) { }

  GetContactList(
    mainAgentId,
    agentUserId,
    userRoleId,
    isResponseSave,
    skip,
    take
  ) {
    return this.http
      .get(
        domain.GetContactList +
        "mainAgentId=" +
        mainAgentId +
        "&agentUserId=" +
        agentUserId +
        "&userRoleId=" +
        userRoleId +
        "&isResponseSave=" +
        isResponseSave +
        "&skip=" +
        skip +
        "&take=" +
        take
      )
      .pipe(map((res: any) => res));
  }
  GetContactUserList(
    mainAgentId,
    agentUserId,
    userRoleId,

  ) {
    return this.http
      .get(
        domain.GetContactUserList +
        "mainAgentId=" +
        mainAgentId +
        "&agentUserId=" +
        agentUserId +
        "&userRoleId=" +
        userRoleId
      )
      .pipe(map((res: any) => res));
  }
  SaveContactReport(details) {
    return this.http
      .post(domain.SaveContactReport, details)
      .pipe(map((res: any) => res));
  }
  DeleteContacts(details) {
    return this.http
      .post(domain.DeleteContacts, details)
      .pipe(map((res: any) => res));
  }
  AssignContactToEmp(details) {
    return this.http
      .post(domain.AssignContactToEmp, details)
      .pipe(map((res: any) => res));
  }
  UnassignAllContacts(mainAgentId: any) {
    return this.http
      .post(domain.UnassignAllContacts, { MainAgentId: mainAgentId })
      .pipe(map((res: any) => res));
  }
  AssignContactsToMultipleEmp(details: any) {
    return this.http
      .post(domain.AssignContactsToMultipleEmp, details)
      .pipe(map((res: any) => res));
  }
  AddAgentCallingLead(details) {
    return this.http
      .post(domain.AddAgentCallingLead, details)
      .pipe(map((res: any) => res));
  }
  UpdateAgentCallingLead(details) {
    return this.http
      .post(domain.UpdateAgentCallingLead, details)
      .pipe(map((res: any) => res));
  }
  DeleteAgentCallingLead(details) {
    return this.http
      .post(domain.DeleteAgentCallingLead, details)
      .pipe(map((res: any) => res));
  }

  ImportContactsFromExcel(details) {
    return this.http
      .post(domain.ImportContactsFromExcel, details)
      .pipe(map((res: any) => res));
  }
  ContactCounts(mainAgentId) {
    return this.http
      .get(domain.ContactCounts + "mainAgentId=" + mainAgentId)
      .pipe(map((res: any) => res));
  }

  CallingAgentLeadList(
    mainAgentId,
    agentUserId,
    userRoleId,
    skip,
    take
  ) {
    return this.http
      .get(
        domain.CallingAgentLeadList +
        "mainAgentId=" +
        mainAgentId +
        "&agentUserId=" +
        agentUserId +
        "&userRoleId=" +
        userRoleId +
        "&skip=" +
        skip +
        "&take=" +
        take
      )
      .pipe(map((res: any) => res));
  }
  SearchActionTakenContactNumber(contactNumber: any,agentUserId: any ) {
    return this.http
      .get(
        domain.SearchActionTakenContactNumber +
        "contactNumber=" +
        contactNumber +
        "&agentUserId=" +
         parseInt(agentUserId)
      )
      .pipe(map((res: any) => res));
  }
  
  GetContactListByType(mainAgentId: any, agentUserId: any, type: any) {
    return this.http
      .get(
        domain.GetContactListByType +
        "mainAgentId=" +
        mainAgentId +
        "&agentUserId=" +
        agentUserId +
        "&type=" +
        type +  
        "&agentUserId=" +
         agentUserId
      )
      .pipe(map((res: any) => res));
  }

  AddCallingMessage(details: {
    MainAgentId: any;
    Header: string;
    Message: string;
  }) {
    return this.http
      .post(domain.AddCallingMessage, details)
      .pipe(map((res: any) => res));
  }

  UpdateCallingMessage(details: {
    Id: any;
    MainAgentId: any;
    Header: string;
    Message: string;
  }) {
    return this.http
      .post(domain.UpdateCallingMessage, details)
      .pipe(map((res: any) => res));
  }

  DeleteCallingMessage(details: { Id: any }) {
    return this.http
      .post(domain.DeleteCallingMessage, details)
      .pipe(map((res: any) => res));
  }

  GetCallingMessagesList(mainAgentId: any) {
    return this.http
      .get(domain.GetCallingMessagesList + "mainAgentId=" + mainAgentId)
      .pipe(map((res: any) => res));
  }

  RemoveCallingResponse(details: { MainAgentId: any; AgentUserId: any }) {
    return this.http
      .post(domain.RemoveCallingResponse, details)
      .pipe(map((res: any) => res));
  }


}
